import { render, staticRenderFns } from "./ManterPalavraChave.vue?vue&type=template&id=e4b6a2b2&scoped=true&"
import script from "./ManterPalavraChave.vue?vue&type=script&lang=js&"
export * from "./ManterPalavraChave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b6a2b2",
  null
  
)

export default component.exports